const SYNTHETIC_GUEST_DOMAIN = "@guest-checkout.arktastic.com";
const EMAIL_PATTERN = /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/;

const normalizedEmail = (value) =>
  typeof value === "string" && EMAIL_PATTERN.test(value.trim())
    ? value.trim().toLowerCase()
    : "";

export const isSyntheticGuestEmail = (value) =>
  normalizedEmail(value).endsWith(SYNTHETIC_GUEST_DOMAIN);

export const firstRealEmail = (...values) => {
  for (const value of values) {
    const email = normalizedEmail(value);
    if (email && !isSyntheticGuestEmail(email)) return email;
  }
  return "";
};

export const resolveCustomerEmail = (customer, ...fallbacks) => {
  const record = customer && typeof customer === "object" ? customer : {};
  const user = record.user && typeof record.user === "object" ? record.user : record;

  return firstRealEmail(
    user.contactEmail,
    record.contactEmail,
    ...fallbacks,
    user.email,
    record.email,
  );
};

export const resolveOrderCustomerEmail = (order) =>
  firstRealEmail(
    order?.customerEmail,
    order?.orderBy?.user?.contactEmail,
    order?.orderBy?.contactEmail,
    order?.customer?.user?.contactEmail,
    order?.customer?.contactEmail,
    order?.orderBy?.user?.email,
    order?.customer?.user?.email,
  );
